const rgbToHex = (rgb) => {
  let hexTemp = []
  let hex     = "#"
      rgb     = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)

  for (let i = 0; i<= 2; i++) {
    hexTemp[i] = Number(rgb[i+1]).toString(16)

    if (hexTemp[i].length < 2)
      hexTemp[i] = '0' + hexTemp[i]

    hex += hexTemp[i]
  }

  return hex
}
/*const clipboardColor = ($colors, $body) => {
  $colors.forEach(($color) => {
    $color.addEventListener('click', (e) => {
      const $fakeInputColor = document.createElement('input')

      $fakeInputColor.value = $color.getAttribute('color-hex')
      $body.appendChild($fakeInputColor)
      $fakeInputColor.select()

      try {
        document.execCommand("copy")
        $fakeInputColor.remove()

        showColorCopied($color)
      }
      catch(err) {
        return false
      }
    })

    return true
  })
}*/
const setColors = ($colors)  => {
  $colors.forEach(($color) => {
    const styles = getComputedStyle($color, null)
    const $colorContainer = $color.closest('.color-container')

    $colorContainer.querySelector('[color-hex]').innerHTML = rgbToHex(styles.backgroundColor)
    $colorContainer.querySelector('[color-rgb]').innerHTML = styles.backgroundColor
  })
}

const Colors = () => {
  const $colors = document.querySelectorAll('[color]')

  if (!$colors.length > 0) return

  setColors($colors)
}

export default Colors
